import { render, staticRenderFns } from "./ShareAction.vue?vue&type=template&id=123fedd0&"
import script from "./ShareAction.vue?vue&type=script&lang=js&"
export * from "./ShareAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports